import { useState, useEffect } from "react";
import axios from "axios";
import { api_v3_get_matches_by_player_and_tournament } from "../../../utils/constants";

const useMatches = (playerId, tournamentId) => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadMatches = async () => {
      setLoading(true);
      try {
        const url = api_v3_get_matches_by_player_and_tournament(
          playerId,
          tournamentId
        );
        const response = await axios.get(url);
        if (response.status === 200) {
          setMatches(response.data);
          setError(false);
        } else {
          console.error(
            `Error fetching matches: ${response.status}`,
            response.data
          );
          setError(true);
        }
      } catch (error) {
        console.error("Error fetching matches:", error);
        setMatches([]);
        setError(false);
      } finally {
        setLoading(false);
      }
    };

    if (playerId && tournamentId) {
      loadMatches();
    }
  }, [playerId, tournamentId]);

  return { matches, loading, error };
};

export default useMatches;
